import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import 'leaflet-draw/dist/leaflet.draw-src.css';
import 'leaflet/dist/leaflet.css';
import './style/map.sass';
import './components/control-buttons/components/all-map-buttons/style.sass';
import { AttributionControl, MapContainer } from 'react-leaflet';
import { useResizeDetector } from 'react-resize-detector';
import { select_ui_settings } from 'console/redux/settings-actions';
import { CustomTileLayers } from 'shared/map/ui/components/tile-layers';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { getCrs } from 'shared/map/lib/get-crs';
import { MapControl } from 'shared/map/ui/components/map-control';
import * as S from './style';
import { useUserLocationMarker } from 'shared/map/ui/components/marker/rotated/hook';
import { ControlButtons } from 'shared/map/ui/components/control-buttons';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const MapWithControls = memo(function MapWithControls(props) {
    const { onClick, device_id, children, hide_for_map_dashboard, showOptionsMenu, showZoom, showSearch, blur, onSearchDone, mapCenterOnUser, } = props;
    const { width, height, ref } = useResizeDetector({
        refreshMode: 'throttle',
        refreshRate: 500,
    });
    const provider = useAppSelector((state) => select_ui_settings(state).map?.provider ?? 'yandex');
    const crs = useMemo(() => getCrs(provider), [provider]);
    const [OrientatedUserLocationMarker, onCenterOnUser] = useUserLocationMarker(device_id);
    return (_jsx(S.BluredMap, { ref: ref, blur: blur, children: _jsx(MapContainer, { className: "r-map", attributionControl: false, zoomControl: false, crs: crs, onclick: onClick, center: [55, 56.3], zoom: 6, children: _jsxs(ErrorBoundary, { children: [_jsx(MapControl, { device_id: device_id, width: width, height: height }), _jsx(AttributionControl, { position: "bottomleft", prefix: "" }), _jsx(CustomTileLayers, {}), _jsx(ControlButtons, { device_id: device_id, hide_for_map_dashboard: hide_for_map_dashboard, showZoom: showZoom, showSearch: showSearch, showOptionsMenu: showOptionsMenu, onSearchDone: onSearchDone, onCenterOnUser: mapCenterOnUser ?? onCenterOnUser }), mapCenterOnUser == null && _jsx(OrientatedUserLocationMarker, {}), children] }) }, `${device_id} ${crs.code}`) }));
});
